// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2246":"ab3fc00e9a9700f7","2365":"698bf7bf4d7833c7","2585":"d93abbd01f80295e","4934":"0e3bd77d9e374aff","5742":"bbfdc57960b6217d","6260":"b5f4f49acbe41dd7","6531":"963091f4e240bb2b","7988":"ba440f327a0f4ebb","8404":"c45e559eb7d1c5fc"}[chunkId] + ".js";
};